<template>
  <BaseButton
    class="dropdown-toggle m-0"
    :class="toggleClass"
    type="button"
    :aria-expanded="isOpen"
  >
    <slot />

    <BaseIcon
      icon="chevron-down"
      tag="i"
      font-scale="0.8"
      class="ml-auto mr-0 flex-grow-0"
    />
  </BaseButton>
</template>

<script>
import { defineComponent, inject } from '@vue/composition-api'

import { BaseButton, BaseIcon } from '@components/base'

import { BaseDropdownInjectionKey } from './BaseDropdown.constants'

export default defineComponent({
  name: 'BaseDropdownToggle',
  components: {
    BaseButton,
    BaseIcon
  },
  setup() {
    const { toggleClass, isOpen } = inject(BaseDropdownInjectionKey)

    return {
      toggleClass,

      isOpen
    }
  }
})
</script>

<style scoped>
.btn::after {
  display: none;
}

.btn {
  padding-right: 10px !important;
}
</style>
